const getAttachmentUrl = ({
  attachmentId,
  size = 68,
}: {
  attachmentId: string
  size?: number
}) => {
  return `/api/attachments/v3/${attachmentId}/thumbnail?width=${size}&height=${size}`
}

export default getAttachmentUrl
